import React from 'react';
import { Wrapper } from './styled';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import { get } from 'lodash';
import { setAgentExecutorSeleted } from 'store/Agents/actions';

const AgentCell = ({ rowInfo }) => {
  const data = get(rowInfo, 'original', {});
  const name = get(data, 'agent_name', '');
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(setAgentExecutorSeleted(data));
    dispatch(openModal(MODAL_AGENT_EXECUTOR_DETAIL));
  };

  return <Wrapper title={ name } onClick={ onClick }>{name}</Wrapper>;
};

export default AgentCell;
